import React from 'react';
import { Routes, Route,Navigate, redirect, useParams } from "react-router-dom";

/** Component Pages Here */
//import MainPage from '../components/pages/MainPage';
import OtherPage from '../components/pages/OtherPage';
import ThankYou from '../components/pages/ThankYou';
import PaymentFailedPage from '../components/pages/PaymentFailedPage';
import InstructionPage from '../components/pages/InstructionPage';

/** V2 */
import MainPageV2 from '../components/pages/MainPageV2';

function MainRoutes(){
    const OrgRedirect = () => {
        const { slug } = useParams();
        const queryString = window.location.search ?? '';

        return <Navigate to={`/${slug}${queryString}`} />
    }  

    return (
        <Routes>
            <Route 
                exact path="/" 
                element={<MainPageV2 />} 
            />

            <Route 
                exact path="manual-instruction" 
                element={<InstructionPage />} 
            />

            <Route 
                exact path="payment/success" 
                element={<ThankYou />} 
            />

            <Route 
                exact path="payment/thankyou" 
                element={<ThankYou />} 
            />


            <Route 
                exact path="payment/failed" 
                element={<PaymentFailedPage />} 
            />

            <Route 
                exact path="payment/cancelled" 
                element={<PaymentFailedPage />} 
            />

            <Route 
                exact path="others" 
                element={<OtherPage />} 
            />

            {/* <Route 
                exact path="/c/:slug" 
                element={<MainPageV2 />} 
            /> */}

            <Route exact path="/c/:slug"
                element={<OrgRedirect />}
            />

            <Route 
                exact path="/:slug" 
                element={<MainPageV2 />} 
            />


            <Route 
                path="*" 
                element={<MainPageV2 />} 
            />

            {/* <Route 
                path="*" 
                element={<Page404 />} 
            /> */}
        </Routes>
    )
}

export default MainRoutes;
